import request from './request'

/** 查询活动跑马灯数据 */
export const marquee = (params?: object) => {
  return request('/finance-common-operation-ws/api/act/marquee/v2/data', params, { loading: false })
}

/** 查询活动信息 */
export const getActConfigByCode = (actCode: string) => {
  return request('/finance-common-operation-ws/api/act/activity/v1/getActivityInfo', { actCode })
}

/** 获取wxJsSdk */
export const getWxJsSdk = (params?: object) => {
  return request(
    '/finance-common-operation-ws/api/act/wechat/v1/getWxJsSdk',
    params,
    { loading: false, showError: false/* , jweixin: true */ }
  )
}
